// extracted by mini-css-extract-plugin
export var dividerLine = "_3w-0";
export var errorBackground = "_3w-1";